module.exports = __webpack_public_path__ + "img/logo-rever-white.596a65df.svg";